<div class="root">
  <div id="alert-success" class="alert alert-success"></div>
  <div id="alert-danger" class="alert alert-danger"></div>
</div>
